import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';
import Button from 'components/ui/Button';

const SPOTLIGHT_MEMBERS = [
{
  id: 1,
  name: "Priya Sharma",
  role: "Real Estate Investor",
  location: "Atlanta, GA",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14172f3b5-1763301352044.png",
  avatarAlt: "Professional Indian woman with long dark hair wearing elegant navy blazer smiling confidently",
  badge: "Pinnacle",
  achievements: ["100K Portfolio", "Mentor", "Course Graduate"],
  bio: "Built a $500K real estate portfolio in 3 years. Passionate about helping women enter the property market.",
  followers: 342,
  investments: 12
},
{
  id: 2,
  name: "Keisha Williams",
  role: "Stock Market Educator",
  location: "Chicago, IL",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15893c078-1772868863440.png",
  avatarAlt: "African American woman with natural hair wearing gold earrings and professional attire",
  badge: "Pinnacle",
  achievements: ["Top Mentor", "WIN Verified", "50 Referrals"],
  bio: "Former Wall Street analyst turned educator. Making investing accessible for every woman.",
  followers: 891,
  investments: 28
},
{
  id: 3,
  name: "Maria Gonzalez",
  role: "Venture Capital Enthusiast",
  location: "Miami, FL",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f9281081-1763294529588.png",
  avatarAlt: "Latina woman with curly brown hair wearing bright smile and professional business attire",
  badge: "Growth",
  achievements: ["Pitch Night Winner", "5 Investments", "Community Leader"],
  bio: "Invested in 5 women-led startups. Advocate for Latina representation in venture capital.",
  followers: 215,
  investments: 5
}];


export default function MemberSpotlight() {
  const [activeIdx, setActiveIdx] = useState(0);
  const member = SPOTLIGHT_MEMBERS?.[activeIdx];

  return (
    <div className="bg-white rounded-xl border overflow-hidden" style={{ borderColor: 'var(--color-border)' }}>
      {/* Header */}
      <div className="px-4 py-3 border-b flex items-center justify-between" style={{ borderColor: 'var(--color-border)', background: 'var(--color-primary)' }}>
        <div className="flex items-center gap-2">
          <Icon name="Star" size={16} color="var(--color-accent)" />
          <h3 className="font-heading font-semibold text-sm text-white">Member Spotlight</h3>
        </div>
        <div className="flex gap-1">
          {SPOTLIGHT_MEMBERS?.map((_, i) =>
          <button key={i} onClick={() => setActiveIdx(i)}
          className="w-2 h-2 rounded-full transition-all"
          style={{ background: i === activeIdx ? 'var(--color-accent)' : 'rgba(255,255,255,0.3)' }} />
          )}
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-start gap-3 mb-3">
          <div className="relative flex-shrink-0">
            <div className="w-14 h-14 rounded-full overflow-hidden border-2" style={{ borderColor: 'var(--color-accent)' }}>
              <Image src={member?.avatar} alt={member?.avatarAlt} className="w-full h-full object-cover" />
            </div>
            <span className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center" style={{ background: 'var(--color-accent)' }}>
              <Icon name="Crown" size={10} color="var(--color-primary)" />
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="font-heading font-semibold text-base" style={{ color: 'var(--color-foreground)' }}>{member?.name}</h4>
            <p className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>{member?.role}</p>
            <div className="flex items-center gap-1 mt-0.5">
              <Icon name="MapPin" size={11} color="var(--color-muted-foreground)" />
              <span className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>{member?.location}</span>
            </div>
          </div>
          <span className="px-2 py-0.5 rounded-full text-xs font-caption font-medium flex-shrink-0"
          style={{ background: 'rgba(133,113,77,0.12)', color: 'var(--color-accent)' }}>
            {member?.badge}
          </span>
        </div>

        <p className="font-body text-xs leading-relaxed mb-3" style={{ color: 'var(--color-muted-foreground)' }}>{member?.bio}</p>

        {/* Achievements */}
        <div className="flex flex-wrap gap-1.5 mb-3">
          {member?.achievements?.map((a) =>
          <span key={a} className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-caption"
          style={{ background: 'var(--color-muted)', color: 'var(--color-foreground)' }}>
              <Icon name="Award" size={10} color="var(--color-accent)" />
              {a}
            </span>
          )}
        </div>

        {/* Stats */}
        <div className="flex gap-4 mb-3 pb-3 border-b" style={{ borderColor: 'var(--color-border)' }}>
          <div className="text-center">
            <p className="font-data font-semibold text-sm" style={{ color: 'var(--color-primary)' }}>{member?.followers}</p>
            <p className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>Followers</p>
          </div>
          <div className="text-center">
            <p className="font-data font-semibold text-sm" style={{ color: 'var(--color-primary)' }}>{member?.investments}</p>
            <p className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>Investments</p>
          </div>
        </div>

        <div className="flex gap-2">
          <Button variant="default" size="sm" fullWidth iconName="UserPlus" iconPosition="left" iconSize={13}>Follow</Button>
          <Button variant="outline" size="sm" fullWidth iconName="MessageCircle" iconPosition="left" iconSize={13}>Message</Button>
        </div>
      </div>
    </div>);

}